import { render, staticRenderFns } from "./TransportationDetailsView.vue?vue&type=template&id=18872caa"
import script from "./TransportationDetailsView.vue?vue&type=script&lang=js"
export * from "./TransportationDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports